import { render, staticRenderFns } from "./edit_translate_text_form.vue?vue&type=template&id=f1a2b916"
import script from "./edit_translate_text_form.vue?vue&type=script&lang=js"
export * from "./edit_translate_text_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports